import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom"

import { AuthProvider } from "./context/AuthContext"
import { ProtectedRoute, PublicOnlyRoute } from "./components/ProtectedRoute"
import DashboardLayout from "./components/layout/DashboardLayout"

import Dashboard from "./pages/Dashboard/Dashboard"
import MembersList from "./pages/Members/MembersList"
import PaymentsList from "./pages/Payments/PaymentsList"
import PaymentView from "./pages/Payments/PaymentView"
import SubscriptionsList from "./pages/Subscriptions/SubscriptionsList"
import SubscriptionView from "./pages/Subscriptions/SubscriptionView"
import AccessLogs from "./pages/AccessLogs/AccessLogs"
import MemberView from "./pages/Members/MemberView"
import NewSubscription from "./pages/Subscriptions/NewSubscription"
import AccessTerminal from "./pages/Access/AccessTerminal"
import EntranceDisplay from "./pages/Access/EntranceDisplay"
import MemberEdit from "./pages/Members/MemberEdit"
import Settings from "./pages/Settings/Settings"
import SettingsPacks from "./pages/Settings/SettingsPacks"
import SettingsUsers from "./pages/Settings/SettingsUsers"
import SettingsGyms from "./pages/Settings/SettingsGyms"
import Login from "./pages/Auth/Login"
import SelfieCapturePage from "./pages/Selfie/SelfieCapturePage"
import { RoleRoute } from "./components/RoleRoute"
import {
  canManageTeamAndCourses,
  canViewEmployeeDirectory,
  canViewFinanceArea,
  canViewTeamArea,
} from "./utils/roles"
import TeamEmployees from "./pages/Team/TeamEmployees"
import TeamCoaches from "./pages/Team/TeamCoaches"
import CoursesList from "./pages/Courses/CoursesList"
import CourseCalendar from "./pages/Courses/CourseCalendar"
import Expenses from "./pages/Expenses/Expenses"
import Accounting from "./pages/Accounting/Accounting"
import Products from "./pages/Products/Products"

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route
            path="/login"
            element={
              <PublicOnlyRoute>
                <Login />
              </PublicOnlyRoute>
            }
          />
          <Route path="/signup" element={<Navigate to="/login" replace />} />
          <Route path="/selfie" element={<SelfieCapturePage />} />

          <Route
            path="/entrance-display"
            element={
              <ProtectedRoute>
                <EntranceDisplay />
              </ProtectedRoute>
            }
          />

          <Route
            path="/*"
            element={
              <ProtectedRoute>
                <DashboardLayout>
                  <Routes>
                    <Route path="/" element={<Dashboard />} />
                    <Route path="/members" element={<MembersList />} />
                    <Route path="/members/:id" element={<MemberView />} />
                    <Route path="/members/edit/:id" element={<MemberEdit />} />
                    <Route path="/subscriptions" element={<SubscriptionsList />} />
                    <Route path="/subscriptions/:id" element={<SubscriptionView />} />
                    <Route path="/payments" element={<PaymentsList />} />
                    <Route path="/payments/:id" element={<PaymentView />} />
                    <Route
                      path="/products"
                      element={
                        <RoleRoute allow={canViewFinanceArea}>
                          <Products />
                        </RoleRoute>
                      }
                    />
                    <Route
                      path="/expenses"
                      element={
                        <RoleRoute allow={canViewFinanceArea}>
                          <Expenses />
                        </RoleRoute>
                      }
                    />
                    <Route
                      path="/accounting"
                      element={
                        <RoleRoute allow={canViewFinanceArea}>
                          <Accounting />
                        </RoleRoute>
                      }
                    />
                    <Route path="/logs" element={<AccessLogs />} />
                    <Route path="/subscriptions/new" element={<NewSubscription />} />
                    <Route path="/access" element={<AccessTerminal />} />
                    <Route path="/settings" element={<Settings />} />
                    <Route path="/settings/gyms" element={<SettingsGyms />} />
                    <Route path="/settings/packs" element={<SettingsPacks />} />
                    <Route
                      path="/settings/users"
                      element={
                        <RoleRoute allow={canManageTeamAndCourses}>
                          <SettingsUsers />
                        </RoleRoute>
                      }
                    />
                    <Route
                      path="/team/employees"
                      element={
                        <RoleRoute allow={canViewEmployeeDirectory}>
                          <TeamEmployees />
                        </RoleRoute>
                      }
                    />
                    <Route
                      path="/team/coaches"
                      element={
                        <RoleRoute allow={canViewTeamArea}>
                          <TeamCoaches />
                        </RoleRoute>
                      }
                    />
                    <Route
                      path="/courses"
                      element={
                        <RoleRoute allow={canViewTeamArea}>
                          <CoursesList />
                        </RoleRoute>
                      }
                    />
                    <Route
                      path="/calendar"
                      element={
                        <RoleRoute allow={canViewTeamArea}>
                          <CourseCalendar />
                        </RoleRoute>
                      }
                    />
                    <Route
                      path="/calendar/coach/:trainerId"
                      element={
                        <RoleRoute allow={canViewTeamArea}>
                          <CourseCalendar />
                        </RoleRoute>
                      }
                    />
                  </Routes>
                </DashboardLayout>
              </ProtectedRoute>
            }
          />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  )
}

export default App
